import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  signalRconnected: null,
  shouldPlaySound: false,
  pendingScannerInput: null,
  options: {
    preOrderDaysAheadAllowed: 0,
  },
});

export const setSignalRState = createAction('SETSIGNALRSTATE');
export const setAlertSoundState = createAction('SETSOUNDSTATE');
export const setPendingScannerInput = createAction('setPendingScannerInput');

export const loadUiOptions = createAction('LOADUIOPTIONS');
export const loadUiOptionsSucceeded = createAction('LOADUIOPTIONSSUCCEEDED');
export const loadUiOptionsFailed = createAction('LOADUIOPTIONSFAILED');

const reducers = createReducer({
  [setSignalRState]: (state, signalRconnected) => state.merge({ signalRconnected }),
  [loadUiOptionsSucceeded]: (state, options) => state.merge({ options }),
  [setAlertSoundState]: (state, shouldPlaySound) => state.merge({ shouldPlaySound }),
}, INITIAL_STATE);

export default reducers;
